export default "__VITE_ASSET__DQsr_k3p__"